<template>
  <div id="app" style="min-width:1240px;" ondragstart="return false">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
import bus from "./components/common/bus";

export default {
  provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
            return {
                reload: this.reload                                              
            }
        },
  data() {
    return {
      isRouterAlive: true
    };
  },
  mounted(){
  },
  methods: {
    reload () {
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
          this.isRouterAlive = true;         //再打开
      }) 
    }
  },
  watch: {
    "$store.state.Status.Status": function() {
      this.$store.commit("Status", true);
      this.$message.error("服务器错误，请联系管理员");
    }
  },
  created() {
    let lastAlertTs = 0;
    bus.$on('update:bid', (newBId, oldBId, updateBId) => {
      const now = Date.now();
      // 最多30s提示一次
      if (now - lastAlertTs < 30 * 1000) {
        return;
      }
      lastAlertTs = now;
      this.$alert("系统已更新，请刷新页面并重新登录！", {
        confirmButtonText: "刷新页面并重新登录",
        showCancelButton: true,
        cancelButtonText: '取消',
        callback: action => {
          switch(action) {
            case 'confirm':
              sessionStorage.clear();
              this.$router.push("/login");
              this.$nextTick(() => {
                updateBId();
                location.reload();
              });
              break
            default: // cancle || close
                break
          }
        }
      });
    });

    // bus.$on("sysOcx2-source-bill-click", row => {
    //   const map = {
    //     合同录入: `/module/gzhc/ctBill/ctBillList`,
    //     合同付款单: `/module/gzhc/ctPaybill/ctPaybillList`,
    //     基本支出预算编制: `/module/gzhc/budgetManagement/basicExpenditure/basicExpenditureList`,
    //     预算明细调整: `/module/gzhc/budgetManagement/projectAdjustment/projectAdjustmentList`,
    //     预算调整: `/module/gzhc/budgetManagement/projectAdjusting/projectAdjustingList`,
    //     预算申报: `/module/gzhc/budgetManagement/projectDeclaration/projectDeclarationList`,
    //     预算申报明细拆解: `/module/gzhc/budgetManagement/projectAdjustment/projectAdjustmentList`,
    //     预算调整明细拆解: `/module/gzhc/budgetManagement/projectAdjusted/projectAdjustedList`,
    //     预算调整批复: `/module/gzhc/budgetManagement/budgetAdjustingReply/budgetAdjustingReply`,
    //     预算调整分配: `/module/gzhc/budgetManagement/projectAdjustingAlloc/projectAdjustingAllocList`,
    //     预算调剂: `/module/gzhc/budgetManagement/budgetSwap/budgetSwapList`,
    //     经费申请单: `/module/gzhc/expenditure/fundApplicationBill/fundApplicationBillList`,
    //     差旅报销单: `/module/gzhc/expenditure//clReimbursement/clReimbursementList`,
    //     借款单: `/module/gzhc/expenditure/loanBill/loanBillList`,
    //     劳务费报销单: `/module/gzhc/expenditure/lwReimbursement/lwReimbursementList`,
    //     餐费报销单: `/module/gzhc/expenditure/mealsReimbursement/mealsReimbursementList`,
    //     其他报销单: `/module/gzhc/expenditure/otherReimbursement/otherReimbursementList`,
    //     还款单: `/module/gzhc/expenditure/refundBill/refundBillList`
    //   };
    //   const page = map[row["sourceBillTypeName"]];
    //   if (page) {
    //     this.$router.push({
    //       path: page,
    //       query: { sourceBillNo: row["sourceBillNo"], t: Date.now() }
    //     });
    //   } else {
    //       `bus sysOcx2-source-bill-click unknown sourceBillTypeName "${row["sourceBillTypeName"]}"`
    //     );
    //   }
    // });
  }
};
</script>

<style lang="scss">
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css";
@media screen and (max-width: 1366px) {
  body {
    zoom: 80% !important;
  }
}
/* 深色主题 */
/* @import "./assets/css/theme-green/color-green.css";   浅绿色主题 */
.Whb {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  padding-bottom: 15px;
}
.el-dialog {
  /*margin-top: 8vh !important;*/
}
.warpCont {
  //所有模块最外层盒子
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px 10px 0 10px;
}
.Change {
  display: inline-block;
  top: 5px;
  left: 10px;
}
.Width-16 {
  width: 16rem;
}
.Width-15 {
  width: 15rem;
}
.Width-14 {
  width: 14rem;
}
.Width-13 {
  width: 13rem;
}
.Width-12 {
  width: 12rem;
}
.Width-11 {
  width: 11rem;
}
.Width-10 {
  width: 10rem;
}
.Width-9 {
  width: 9rem;
}
.el-menu {
  border-right: none !important;
  background: none !important;
}
/* 兼容webkit内核，谷歌，360浏览器等 */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 3px;
}
.el-dropdown {
  cursor: pointer;
}
.container {
  border: 1px solid #ddd;
  border-radius: 5px;
}
.UserPost .warpCont {
  width: 100%;
  height: 100%;
}
.UserPost {
  padding-bottom: 15px !important;
  padding-right: 15px;
}
/* 树状横向滚动条 */
.el-tree {
  width: 100%;
  overflow: scroll;
  z-index: 99;
}
.el-tree > .el-tree-node {
  //为了可在树状列表加入滚动条，须修改样式
  display: inline-block;
  min-width: 100%;
}
.searcher {
  //搜索，显示隐藏查询框，打开关闭树状表格 （按钮的样式）
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.3s;
  font-weight: 500;
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 10px;
  &:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}
.aa {
  //搜索按钮动画
  transition: all 0.6s;
  transform: rotate(0deg);
  display: inline-block;
}
.go {
  //搜索按钮动画
  transform: rotate(360deg);
  transition: all 0.6s;
  display: inline-block;
}
.CommList {
  //地区档案，客商类型，工程类型，项目类型，科目档案 第一层与第二层盒子类名
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  position: relative;
  box-sizing: border-box;
  padding-bottom: 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -ms-perspective: 1000;
  perspective: 1000;
}
.CommList .pagination {
  //分页组件样式
  position: absolute;
  // bottom: 5px;
  right: 10px;
}
.pagination {
  position: absolute;
  // bottom: 5px;
  right: 10px;
  width: 100%;
  text-align: right;
}
.CommSearch {
  //地区档案，客商类型，工程类型，项目类型，科目档案 搜索框最外层盒子类名
  background: #fff;
  border-radius: 6px;
  padding: 0px 10px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 12%;
  box-sizing: border-box;
  transition: all 0.3s;
  overflow: auto;
}
.CommHeight {
  //地区档案，客商类型，工程类型，项目类型，科目档案 搜索框内容高度
  height: 36px;
  line-height: 36px;
  text-align: center;
}
.Table {
  //地区档案，客商类型，工程类型，项目类型，科目档案 表格内容外层盒子 底部没有分页 树状表格;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 6px;
  overflow-y: auto;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
  position: relative;
  padding-top: 50px;
  padding-bottom: 56px;
}
.TreeTable {
  //客商档案，合同外原因，清单定额标准，服务阶段，编制依据 表格底部有分页
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
  position: relative;
  padding-top: 50px;
  padding-bottom: 56px;
}
.Tabel_Top {
  //地区档案，客商类型，工程类型，项目类型，科目档案 表格内容按钮的最外层盒子
  height: 50px;
  line-height: 50px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.ComButtonLeft {
  //地区档案，客商类型，工程类型，项目类型，科目档案 表格内容左侧按钮的最外层盒子
  float: left;
  padding-left: 10px;
}
.ComButtonRight {
  //地区档案，客商类型，工程类型，项目类型，科目档案 表格内容右侧按钮的最外层盒子
  float: right;
  padding-right: 10px;
}
.el-table__row .el-radio__label {
  //单选框居中效果
  display: none;
}
//正常input边框颜色
.value {
  height: 32px;
  line-height: 32px;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
//当input框内容为空时，边框为红色
.empty {
  height: 32px;
  line-height: 32px;
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  border: 1px solid #ff0000 !important;
}
//下拉选择框
.select_value {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  opacity: 0.8;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  .el-input__inner {
    height: 34px;
    line-height: 34px;
    border: none;
  }
}
.select_empty {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #ff0000;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #abafb6 !important;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  .el-input__inner {
    height: 34px;
    line-height: 34px;
    border: none;
    color: #abafb6 !important;
  }
}
.icon .cell::before {
  //table表格头部加必填验证的字体图标
  content: "*";
  color: red !important;
  margin-right: 4px;
}

.rowHeight {
  height: 40px;
  // line-height: 40px;
}
.time_icon {
  .el-input__suffix {
    right: 5px;
  }
}
.el-table--border {
  height: 100%;
}
.el-message {
  top: 20px !important;
}
.input .el-form-item__content {
  width: 200px !important; //新增，编辑界面的input盒子宽度
}
.max-input .el-form-item__content {
  width: 300px !important; //新增，编辑界面的input盒子宽度
}
@media screen and (max-width: 1240px) {
  .content-box {
    min-width: 1351px;
  }
  html,
  body,
  #app,
  .wrapper{
    overflow: inherit;
    min-width: 1240px;
  }
  html{
    overflow-y: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue